"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSetLink = void 0;
var handleSetLink = function (editor, url) {
    if (url === null) {
        return;
    }
    if (url === '') {
        editor.chain().focus().extendMarkRange('link').unsetLink().run();
        return;
    }
    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
};
exports.handleSetLink = handleSetLink;
//# sourceMappingURL=utils.js.map